import { http } from "@/helpers/http";
import Vue from 'vue'

// const baseURL = 'https://4fy3jitdyd.execute-api.us-east-1.amazonaws.com/dev/v1';
// const baseURL = 'http://localhost:3000/dev/v1';

const baseURL = "/shippers/v1";

export default {
  namespaced: true,
  state: {
    shippers: null
  },

  getters: {
    shippers(state) {
      return state.shippers;
    },
  },

  mutations: {
    setShippers(state, shippers) {
      Vue.set(state, 'shippers', shippers);
    },
  },

  actions: {
    async fetchShipper({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.get(`${baseURL}/shippers/${payload.id}`)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async fetchShippers({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.get(baseURL + "/shippers", { params: payload.params })
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async createShipper({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseURL + "/shippers", payload.shipper);
        return { status: true, data };
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    },

    async updateShipper({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.put(baseURL + "/shippers/" + payload.id, payload.shipper);
        return { status: true, data };
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    },

    async deleteShipper({ state, commit, rootState }, payload) {
      try {
        await http.delete(baseURL + "/shippers/" + payload.id);
        return { status: true };
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    }
  }
};
